// @flow
import React, { type Node, Fragment, useCallback, useState } from 'react';

import type { Subject } from 'app/dataTypes/ScheduleWeek.types';

import { availableTabs as at } from './Tab';
import SubjectTitle from './cells/SubjectTitle';
import Marks from './cells/Marks';
import Bells from './cells/Bells';
import Overflowed from './cells/Overflowed';
import Task from './cells/Task';
import ScheduleRowTemplate from './ScheduleRowTemplate';
import VideomeetLink from './VideomeetLink';
import Solutions from './Solutions';
import Attached from './Attached';


type Props = {
  num: number,
  currentTab: $Values<typeof at>,
  data: Subject,
  studentId: string,
}

const ScheduleRow = ({ num, currentTab, data, studentId }: Props): Node => {
  const [assigments, setAssigments] = useState<Array<number>>([]);
  const handleAssignmentLoad = useCallback((scheduleId: number, assigmentIds: Array<number>) => {
    setAssigments(assigmentIds);
  }, []);

  const {
    title,
    videomeetLink,
    startAt,
    endAt,
    marks,
    room,
    theme,
    homeworkTask,
    homeworkSolutionScheduleId,
    homeworkAssignmentScheduleIds,
  } = data;

  return (
    <ScheduleRowTemplate
      num={num}
      contentSubject={
        <SubjectTitle title={title}>
          <VideomeetLink videomeetLink={videomeetLink} />
        </SubjectTitle>
      }
      contentMain={
        <Fragment>
          {currentTab === at.TASK
            && <Task taskDescription={homeworkTask}>
              {homeworkAssignmentScheduleIds.map(scheduleId => (
                <Attached
                  key={scheduleId}
                  scheduleId={scheduleId}
                  onAssignmentLoad={handleAssignmentLoad}
                />
              ))}
            </Task>}

          {currentTab === at.BELLS
            && <Bells startAt={startAt} endAt={endAt} />}

          {currentTab === at.ROOM
            && <Overflowed>{room}</Overflowed>}

          {currentTab === at.THEME
            && <Overflowed>{theme}</Overflowed>}
        </Fragment>
      }
      contentMarks={
        <Marks marks={marks}>
          <Solutions
            studentId={parseInt(studentId, 10)}
            scheduleId={parseInt(homeworkSolutionScheduleId, 10)}
            assignmentIds={assigments}
          />
        </Marks>
      }
    />
  );
};

export default ScheduleRow;
